import React from 'react';

import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';

import { SmsConversationType } from '../types';
import { useOpenStartConversationModal } from './hooks';
import { StartConversationModal } from './StartConversationModal';

interface StartConversationButtonProps {
  onSelectTalent: (conversation: SmsConversationType) => void;
}

const StartConversationButton: React.FC<StartConversationButtonProps> = ({
  onSelectTalent,
}) => {
  const openStartConversationModal = useOpenStartConversationModal();

  const handleOpen = () => {
    openStartConversationModal();
  };

  return (
    <>
      <Button
        variant="contained"
        color="info"
        startIcon={<AddIcon />}
        onClick={handleOpen}
        fullWidth
        sx={{ mb: 2 }}
      >
        New Conversation
      </Button>

      <StartConversationModal onSelectTalent={onSelectTalent} />
    </>
  );
};

export default StartConversationButton;

